import { DRAWER_COLLAPSE, DRAWER_OPEN } from "../action-types/drawer"

export const openDrawer = () =>
    (dispatch) => {
        dispatch({
            type: DRAWER_OPEN
        })
    }

export const collapseDrawer = () =>
    (dispatch) => {
        dispatch({
            type: DRAWER_COLLAPSE
        })
    }
